import Modal from 'react-bootstrap/Modal';
import { useWeb3React } from "@web3-react/core";
import { useState, useRef, useEffect } from 'react';
import "./createnewtoken.scss"
import Navbar from '../landing/header/Navbar';
import { api_url } from "../../utils/Enviroment";
import axios from "axios";
import { toast } from "react-toastify";
import Accordion from 'react-bootstrap/Accordion';
import CreateToken from '../../hooks/dataSender/CreateToken';
import Loader from '../../loader';
import Balance from '../../hooks/dataFetcher/BalanceOf';
import { capitalizeFirstLetter, formatEthinDollar, getInitials } from '../../utils/helpers';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import RefreshToken from '../../hooks/refreshToken';
import Footernew from '../landing/footernew/Footernew';
import { buyingToken, ethToDollarConverter, getEpochTime, getFutureEpochTime, getIsNameExists } from '../../utils/services/service';
import AmountOut from '../../hooks/dataFetcher/AmountOut';

const Createnewtoken = () => {
    const { provider } = useWeb3React();
    const { refreshTokenApi } = RefreshToken();
    const { CreateTokenHook } = CreateToken();
    const [loader, setLoader] = useState(false);
    const { BalanceHook } = Balance();
    const { AmountOutHook } = AmountOut();
    let { account } = useWeb3React();
    const fileInputRef = useRef(null);
    const [projectName, setProjectName] = useState("");
    const [contractAddress, setContractAddress] = useState("");
    const [alreadyCreatedToken, setAlreadyCreatedToken] = useState("");
    const [projectBannerImg, setProjectBannerImg] = useState("");
    const [logoFile, setLogoFile] = useState(null);
    const [projectId, setProjectId] = useState("");
    const [loaderMessage, setLoaderMessage] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [firstBuyAmount, setFirstBuyAmount] = useState("0");
    const [ethBalance, setEthBalance] = useState(null);
    const [amountOfToken, setAmountOfToken] = useState("0");
    const [ethPrice, setEthPrice] = useState(0);
    const activeCreateButton = !!projectName && !/^\s+$/.test(projectName) && +ethBalance >= +firstBuyAmount;


    const fetchEthBalance = async () => {
        try {
            const balance = await BalanceHook();
            setEthBalance(balance);
        } catch (error) {
            console.error("Error fetching ETH balance:", error);
        }

    };

    const handleTransactionTime = async () => {
        try {
            const epochTime = await getEpochTime(provider);
            return createTokenHandle(epochTime);
        } catch (error) {
            console.error("Error fetching transaction time:", error);
        }

        try {
            const futureTime = await getFutureEpochTime();
            return createTokenHandle(futureTime);
        } catch (error) {
            console.error("Error fetching Future UTC time:", error);
        }
        const fallbackTime = Math.floor((Date.now() + 600000) / 1000);
        createTokenHandle(fallbackTime);
    };

    const createTokenHandle = async (time) => {
        if (!account) {
            toast?.error("Please connect your wallet");
            return;
        }
        setLoader(true);

        try {
            const normalizeProjectName = capitalizeFirstLetter(projectName)
            const ticker = getInitials(normalizeProjectName);
            const createdTokenData = await getIsNameExists(normalizeProjectName, ticker, time, account);
            if (createdTokenData?.isExisting) {
                setAlreadyCreatedToken(createdTokenData);
                setLoader(false);
                return;
            } else {
                setLoaderMessage("Confirm Create Transaction");
                setAlreadyCreatedToken("")
                const res = await CreateTokenHook(normalizeProjectName, ticker, time, firstBuyAmount, createdTokenData?.signature);
                if (res) {
                    const { events, transactionHash } = res;
                    const contractAddress = res?.events?.Launch?.returnValues?.namesToken;
                    const pair = events?.Launch?.returnValues?.pair;

                    setContractAddress(contractAddress);
                    await createToken(contractAddress, transactionHash, pair, ticker);
                }
                return res;
            }
        } catch (error) {
            if (error.response?.status === 401) {
                try {
                    const newToken = await refreshTokenApi();
                    if (newToken) return createTokenHandle();
                } catch (refreshError) {
                    console.error("Error in refresh token:", refreshError);
                    toast.error("Session expired. Please login again.");
                }
            } else {
                console.error("Error in createTokenHandle:", error);
                setImageUrl("");
                setLoader(false);

                const errorMsg = error?.code === 4001 ? "User Rejected!" : "Transaction Failed!";
                toast?.error(errorMsg);
            }
        }
    };



    const handleImageUpload = (event) => {
        const file = event.target.files[0];

        if (file) {
            const validTypes = ["image/jpeg", "image/png", "image/gif"];
            if (!validTypes.includes(file.type)) {
                toast.error("Incorrect Image Type");
                return;
            }
            if (file.size > 5 * 1024 * 1024) {
                toast.error("Image must be less than 5MB");
                return;
            }
            const fileName = file.name.replace(/\s+/g, "_");
            const newFile = new File([file], fileName, { type: file.type });
            const imageUrl = URL.createObjectURL(newFile);
            const formData = new FormData();
            formData.append("image", newFile);

            setLogoFile(formData);
            setProjectBannerImg(imageUrl);
        }
    };

    const removeImg = () => {
        setProjectBannerImg(null);
        setLogoFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };


    const [copied, setCopied] = useState(false); // State to show "Copied" message

    const handleCopy = () => {
        if (contractAddress) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(contractAddress)
                    .then(() => {
                        setCopied(true);
                        setTimeout(() => setCopied(false), 2000);
                    })
                    .catch((err) => { });
            } else {
                // Fallback for unsupported environments
                const textArea = document.createElement("textarea");
                textArea.value = contractAddress;
                document.body.appendChild(textArea);
                textArea.select();
                try {
                    document.execCommand('copy');
                    setCopied(true);
                    setTimeout(() => setCopied(false), 2000);
                } catch (err) {
                    console.error("Failed to copy URL using fallback:", err);
                }
                document.body.removeChild(textArea);
            }
        }
    };
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        setProjectName("");
    };
    const handleShow = () => setShow(true);

    const createToken = async (contractAddress, transactionHash, pairAddress, ticker) => {
        setLoaderMessage("Processing...")
        const normalizeProjectName = capitalizeFirstLetter(projectName)
        const token = localStorage?.getItem("accessToken");
        setLoader(true);
        if (!account) {
            toast.error("Connect Wallet To Create")
            return;
        }
        try {
            const payload = {
                projectName: normalizeProjectName,
                ticker: ticker,
                creatorAddress: account,
                contractAddress: contractAddress,
                pairAddress: pairAddress,
                txHash: transactionHash,
            };
            const collectionResponse = await axios.post(`${api_url}project/create-project`, payload, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });

            if (collectionResponse) {
                setProjectId(collectionResponse?.data?.data?._id);
                if (+firstBuyAmount > 0) {
                    await buyingToken(account,collectionResponse?.data?.data?.contractAddress)
                }
            }

            handleShow();
            setLoader(false);
        } catch (error) {
            setLoader(false);
            toast.error(error.message);
        }
    };

    const fetchEthValue = async () => {
        const ethAmount = await ethToDollarConverter();
        setEthPrice(ethAmount);
    };

    useEffect(() => {
        fetchEthBalance();
        fetchEthValue();
    }, [account]);

    useEffect(() => {
        if (+firstBuyAmount > 0) {
            const timeout = setTimeout(async () => {
                try {
                    const amountOut = await AmountOutHook(firstBuyAmount);
                    setAmountOfToken(amountOut);
                } catch (error) {
                    console.error("Error fetching amountOut:", error);
                }
            }, 800);

            return () => clearTimeout(timeout);
        }
    }, [firstBuyAmount]);

 

    return (
        <>
            {loader && <Loader text={loaderMessage} />}
            <Navbar />
            <section className='createnewtoken'>
                <div className='custom-container'>
                    <div className='parentbox'>
                        <h2 >Create Name</h2>

                        <div className='maininputs'>
                            <div className='innerinputs'>
                                <input className={alreadyCreatedToken ? "error-input" : 'active-input'}
                                    type='text'
                                    maxLength="45"
                                    placeholder='Enter name'
                                    value={projectName}
                                    onChange={(e) => {
                                        setProjectName(e.target.value);
                                        alreadyCreatedToken && setAlreadyCreatedToken("")
                                    }} />
                                {alreadyCreatedToken ? <p className='error-message'>This name already exists. Try another name.</p> : ""}
                            </div>



                        </div>
                        {alreadyCreatedToken ?
                            <div className='create_name_bar'>
                                <div className='video_side'>
                                    <video className='main-banner-video'
                                        muted="muted" playsinline="playsinline"
                                        autoPlay
                                        loop
                                        width="100%"
                                        id="myVideo">
                                        <source src="https://d381ze7vrxmjbo.cloudfront.net/gifs/bannervideo.mp4" type="video/mp4" />
                                    </video>
                                    <h1>{alreadyCreatedToken?.name}</h1>

                                </div>
                                <div className='top_details'>
                                    <div className='created_by_text'>
                                        <h2>Created By</h2>
                                        <h3>{alreadyCreatedToken?.creatorAddress?.slice(0, 5)}...{alreadyCreatedToken?.creatorAddress?.slice(-3)}</h3>
                                    </div>
                                    <Link to={`/coin/${alreadyCreatedToken?.id}`}>
                                        <div className='view_detaill'>
                                            View Details
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <g clip-path="url(#clip0_587_68)">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.29279 6.29303C6.48031 6.10556 6.73462 6.00024 6.99979 6.00024C7.26495 6.00024 7.51926 6.10556 7.70679 6.29303L12.7068 11.293C12.8943 11.4806 12.9996 11.7349 12.9996 12C12.9996 12.2652 12.8943 12.5195 12.7068 12.707L7.70679 17.707C7.51818 17.8892 7.26558 17.99 7.00339 17.9877C6.74119 17.9854 6.49038 17.8803 6.30497 17.6948C6.11956 17.5094 6.01439 17.2586 6.01211 16.9964C6.00983 16.7342 6.11063 16.4816 6.29279 16.293L10.5858 12L6.29279 7.70703C6.10532 7.5195 6 7.26519 6 7.00003C6 6.73487 6.10532 6.48056 6.29279 6.29303ZM12.2928 6.29303C12.4803 6.10556 12.7346 6.00024 12.9998 6.00024C13.265 6.00024 13.5193 6.10556 13.7068 6.29303L18.7068 11.293C18.8943 11.4806 18.9996 11.7349 18.9996 12C18.9996 12.2652 18.8943 12.5195 18.7068 12.707L13.7068 17.707C13.5182 17.8892 13.2656 17.99 13.0034 17.9877C12.7412 17.9854 12.4904 17.8803 12.305 17.6948C12.1196 17.5094 12.0144 17.2586 12.0121 16.9964C12.0098 16.7342 12.1106 16.4816 12.2928 16.293L16.5858 12L12.2928 7.70703C12.1053 7.5195 12 7.26519 12 7.00003C12 6.73487 12.1053 6.48056 12.2928 6.29303Z" fill="#191919" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_587_68">
                                                        <rect width="24" height="24" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div></Link>
                                </div>

                            </div> : ""}


                        <div className='accordian_parent'>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <div className='header_of_accordian'>
                                            <h1>Do you want to buy any tokens in the start?</h1>
                                            <p>Its optional but buying a small amount helps protect your coin from snipers</p>
                                        </div></Accordion.Header>
                                    <Accordion.Body>
                                        <div className='accor_body'>
                                            <div className='inner_boddy'>
                                                <div className='input_nd_value'>
                                                    <input value={firstBuyAmount} onChange={(e) => setFirstBuyAmount(e.target.value)} type='number' placeholder='0.00' />
                                                    <p className='doller_value'>${formatEthinDollar(+firstBuyAmount, ethPrice)}</p>
                                                </div>

                                                <h3><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                    <g clip-path="url(#clip0_1158_273)">
                                                        <path d="M1.62732 5.47242V12.5284C1.62732 12.982 1.86492 13.3924 2.26092 13.6228L8.37372 17.1508C8.76252 17.374 9.24492 17.374 9.63372 17.1508L15.7465 13.6228C16.1353 13.3996 16.3801 12.982 16.3801 12.5284V5.47242C16.3801 5.01882 16.1425 4.60842 15.7465 4.37802L9.63372 0.850017C9.24492 0.626817 8.76252 0.626817 8.37372 0.850017L2.26092 4.37802C1.87212 4.60122 1.63452 5.01882 1.63452 5.47242H1.62732Z" fill="#213147" />
                                                        <path d="M10.3321 10.3677L9.4609 12.7581C9.4393 12.8229 9.4393 12.8949 9.4609 12.9669L10.9585 17.0781L12.6937 16.0773L10.6129 10.3677C10.5625 10.2381 10.3825 10.2381 10.3321 10.3677Z" fill="#12AAFF" />
                                                        <path d="M12.0817 6.35013C12.0313 6.22053 11.8513 6.22053 11.8009 6.35013L10.9297 8.74053C10.9081 8.80533 10.9081 8.87733 10.9297 8.94933L13.3849 15.6813L15.1201 14.6805L12.0817 6.35733V6.35013Z" fill="#12AAFF" />
                                                        <path d="M9.00006 1.116C9.04326 1.116 9.08646 1.1304 9.12246 1.152L15.7321 4.968C15.8113 5.0112 15.8545 5.0976 15.8545 5.184V12.816C15.8545 12.9024 15.8041 12.9888 15.7321 13.032L9.12246 16.848C9.08646 16.8696 9.04326 16.884 9.00006 16.884C8.95686 16.884 8.91366 16.8696 8.87766 16.848L2.26806 13.032C2.18886 12.9888 2.14566 12.9024 2.14566 12.816V5.1768C2.14566 5.0904 2.19606 5.004 2.26806 4.9608L8.87766 1.1448C8.91366 1.1232 8.95686 1.1088 9.00006 1.1088V1.116ZM9.00006 0C8.76246 0 8.53206 0.0576 8.31606 0.18L1.70646 3.996C1.28166 4.2408 1.02246 4.6872 1.02246 5.1768V12.8088C1.02246 13.2984 1.28166 13.7448 1.70646 13.9896L8.31606 17.8056C8.52486 17.928 8.76246 17.9856 9.00006 17.9856C9.23766 17.9856 9.46806 17.928 9.68406 17.8056L16.2937 13.9896C16.7185 13.7448 16.9777 13.2984 16.9777 12.8088V5.1768C16.9777 4.6872 16.7185 4.2408 16.2937 3.996L9.67686 0.18C9.46806 0.0576 9.23046 0 8.99286 0H9.00006Z" fill="#9DCCED" />
                                                        <path d="M4.62244 15.689L5.23444 14.0186L6.45844 15.0338L5.31364 16.085L4.62244 15.689Z" fill="#213147" />
                                                        <path d="M8.43841 4.63708H6.76081C6.63841 4.63708 6.52321 4.71628 6.48001 4.83148L2.88721 14.6811L4.62241 15.6819L8.58241 4.83148C8.61841 4.73068 8.54641 4.62988 8.44561 4.62988L8.43841 4.63708Z" fill="white" />
                                                        <path d="M11.376 4.63708H9.6984C9.576 4.63708 9.4608 4.71628 9.4176 4.83148L5.3136 16.0779L7.0488 17.0787L11.5128 4.83148C11.5488 4.73068 11.4768 4.62988 11.376 4.62988V4.63708Z" fill="white" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_1158_273">
                                                            <rect width="18" height="18" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>ETH</h3>
                                            </div>
                                            {+firstBuyAmount > 0 ?
                                                <p>You receive: {amountOfToken ? Number(amountOfToken).toFixed(2) : "0.00"} {capitalizeFirstLetter(projectName)}</p> : " "}
                                        </div>

                                    </Accordion.Body>
                                </Accordion.Item>

                            </Accordion>
                        </div>
                        <div className='lastbuttons'>
                            <Link className='backk_buttons' to="/">
                                Back
                            </Link>

                            <button className={activeCreateButton ? "active" : 'dull'} onClick={handleTransactionTime} disabled={!activeCreateButton}>Create</button>
                        </div>

                    </div>
                </div>
            </section>
            <Footernew />
            <Modal className='token' show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Name Created</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='parent' style={{ display: 'flex', justifyContent: 'center' }}>

                        <div className='project_moddal'>
                            <video className='main-banner-video'
                                muted="muted" playsinline="playsinline"
                                autoPlay
                                loop
                                width="100%"
                                id="myVideo">
                                <source src="https://d381ze7vrxmjbo.cloudfront.net/gifs/bannervideo.mp4" type="video/mp4" />
                            </video>
                            <p>{capitalizeFirstLetter(projectName)}</p>
                        </div>
                        <h2 className='mainheading'>Token created successfully!</h2>
                        <p className='mainpara'>Here’s the contract address.</p>
                        <div className="bottombox" style={{ textAlign: 'center', flexDirection: 'column' }}>
                            <p className='pcopiedddd'>
                                {contractAddress?.slice(0, 20)}.....{contractAddress?.slice(-15)}
                                {copied ? (

                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M12 3L5.125 10L2 6.81818" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                ) : (

                                    <svg onClick={handleCopy}
                                        style={{ cursor: "pointer", marginBottom: '5px' }} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <g clipPath="url(#clip0_168_2044)">
                                            <path d="M10 4H5C4.44772 4 4 4.44772 4 5V10C4 10.5523 4.44772 11 5 11H10C10.5523 11 11 10.5523 11 10V5C11 4.44772 10.5523 4 10 4Z" stroke="#191919" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M2 8C1.45 8 1 7.55 1 7V2C1 1.45 1.45 1 2 1H7C7.55 1 8 1.45 8 2" stroke="#191919" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_168_2044">
                                                <rect width="12" height="12" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                )}
                            </p>
                        </div>

                        <div className='continuebuttton'>
                            <Link to={`/coin/${projectId}`}>
                                <button>Continue</button>
                            </Link>
                        </div>
                    </div>

                </Modal.Body>

            </Modal>
        </>
    )
}

export default Createnewtoken